import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-context-menu-option',
  templateUrl: './context-menu-option.component.html'
})
export class ContextMenuOptionComponent implements OnInit {
  @Input() link: string;
  @Input() disabled = false;

  constructor(private _router: Router) { }

  ngOnInit() {
  }

  go(link: string, message: string = '') {
    if (!this.disabled) {
      if (!this.link || (message && !window.confirm(message))) {
        return;
      }
      this._router.navigate([link]);
    }
  }
}
